var buttonBtnTypeData = ['default', 'outlined', 'link'];
export default buttonBtnTypeData;